/* eslint-disable eag/match-named-export */
import {buildArray, Nullish} from 'shared/web';

import {FeatureStateFlagSeverity} from '../components/FeatureStateFlag/FeatureStateFlag';
import {
  ListFeatureFlagItem,
  ListFeaturesItemProps,
} from '../components/ListFeatures/components/ListFeaturesItem';
import {isListFeatureVisible} from './isListFeatureVisible';

type FeaturesType = {
  title: string | null;
  variant: FeatureStateFlagSeverity;
  label: string | null;
  isMandatory: boolean | Nullish;
  description: string | Nullish;
  tooltipText?: string | Nullish;
  flagTexts?: ListFeatureFlagItem[] | Nullish;
};

export function createFeaturesList(features: FeaturesType[], showEmptyFields: boolean = false) {
  return features.reduce((builder, feature) => {
    const listFeature = {
      title: feature.title,
      flagText: feature.label,
      variant: feature.variant,
      description: feature.description,
      tooltipText: feature.tooltipText,
      flagTexts: feature.flagTexts,
    };

    return builder.when(
      isListFeatureVisible(listFeature, showEmptyFields),
      listFeature as ListFeaturesItemProps
    );
  }, buildArray<ListFeaturesItemProps>());
}
